<template>
    <div>
        <v-btn primary v-if="!url" @click="generate">
            {{ concern === 'patient' ? 'Générer lien pour patient' : 'Générer lien pour docteur'}}
        </v-btn>
        <div v-else>
            <p style="word-break: break-all;">
                Lien pour: {{ concern === 'patient' ? 'patient' : 'docteur'}}
                <br>
                {{ url }}
            </p>
            <v-btn
                primary
                v-clipboard:copy="url"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
            >
                <v-icon primary medium>mdi-clipboard</v-icon>
                Copier le lien
            </v-btn>
        </div>
        <br>
    </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "FollowUpUrl",
    props: {
        step: {
            type: Number,
            required: true
        },
        treatment: {
            required: true
        },
        concern: {
            type: String,
            required: true
        }
    },
    data: () => ({
        url: null
    }),
    methods: {
        ...mapActions('follow_ups', ['generateSignedUrl']),
        ...mapActions('notifications', ['alertSuccess', 'alertError']),
        generate() {
            this.generateSignedUrl({'followUpDefinition': this.step, 'concern': this.concern}).then(response => {
                this.url = response.data.url_notification
            })
        },
        onCopy() {
            this.alertSuccess({
                title: 'Succès', content: 'lien copié'
            })
        },
        onError() {
            this.alertError({
                title: 'Erreur', content: 'le lien n\'a pas été copié'
            })
        },
    }
}
</script>

<style scoped>

</style>
